module.exports = __webpack_public_path__ + "img/left_md_3.8ca4e341.jpg";